var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartWrapper",staticClass:"widget-wrapper"},[_c('div',{staticClass:"widget-contents"},[_c('div',{staticClass:"widget-contents-wrapper"},[_c('word-cloud-chart',{ref:"chartInstance",attrs:{"data":_vm.widgetData,"tooltip":_vm.tooltip,"auto-resize":true}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }